<ul class="flex flex-col gap-2 text-sm text-shikenso-purple-base">
  @for (item of items(); track item.label) {
    <li class="flex items-center gap-2">
      <span
        aria-hidden="true"
        class="h-2 w-4 shrink-0 rounded-sm"
        [attr.data-tone]="item.tone"
        [style.background]="getBarToneBackground(item.tone)"
      ></span>
      <span>{{ item.label | translate }}</span>
    </li>
  }
</ul>

@if (footnote()) {
  <p class="mt-3 text-xs text-shikenso-purple-base-60">{{ footnote()! | translate }}</p>
}
